;(function ( $, window, document, undefined ) {
    var pluginName = "teamtype",
        defaults = {};

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

		init: function() {
			this.setElements();
			this.setVars();
			this.setDatas();
		},

		setElements: function(e) {
			this.$element = $(this.element);
			this.$pitch = this.$element.find(".js-teamtype");
		},

		setVars: function() {
			this.url = this.$element.data("teamtype");
			this.tplTeamtype = $("#tpl-teamtype").html();
			$("#tpl-teamtype").remove();
		},
		
		setDatas: function() {
			if (this.$xhr)
				return false;

			this.$xhr = $.ajax(this.url, {
				dataType: "xml",
				cache : false
			}).done($.proxy(function(xml) {
				var xmlPlayers = [];
				var players = $(xml).find("eqtype:eq(0) joueur");
				for (var i in players) {
					var xmlPlayer = {};
					if (players[i].attributes && players[i].childNodes) {
						$(players[i].attributes).each(function(i) {
							xmlPlayer[this.name] = this.value ? this.value : '';
						});
						$(players[i].childNodes).each(function(i) {
							xmlPlayer[$(this).get(0).tagName] = $(this).text() ? $(this).text() : '';
						});
						xmlPlayers.push(xmlPlayer);
					}
				}
				this.setDatasVars(xmlPlayers);
				this.setTeamtype();
			}, this)).always($.proxy(function() {
				this.$xhr = null;
			}, this));
		},

		setDatasVars: function (xmlPlayers) {
			this.playersTeam = [];
			if (xmlPlayers) {
				for (var i in xmlPlayers) {
					var item = xmlPlayers[i];
					var player = {};
					player["id"] = item["idjoueur"];
					player["teamid"] = item["idclub"];
					player["number"] = isNaN(item["note"]) ? '' : item["note"];
					if (parseInt(item["x"]) && parseInt(item["y"])) 
						player["position"] = {"right":item["x"] * 100 / 460, "top":item["y"] * 100 / 400};
					player["firstname"] = item["prenom"];
					player["lastname"] = item["nom"];
					player["tooltip"] = item["nom"].toUpperCase();
					player["gear"] = 1;

					this.playersTeam.push(player);
				}
			}
		},

		setTeamtype: function() {
			Mustache.parse(this.tplTeamtype);
            var html = Mustache.render(this.tplTeamtype, this.playersTeam);
            this.$pitch.html(html);
		}

  	});

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );